import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper'

Swiper.use([Autoplay, Navigation, Pagination, Thumbs])

const sliders = document.querySelectorAll('.slider:not(.thumbnails)')

sliders.forEach(el =>
{
	initSlider(el)
})

function initSlider (el)
{
	const responsive = el.dataset.responsive || 0
	const direction = el.dataset.direction || 'horizontal'
	const autoplay = el.dataset.autoplay ? {
		delay: el.dataset.autoplay
	} : false
	const loop = !!el.dataset.loop
	const freeMode = !!el.dataset.freemode
	const speed = el.dataset.speed || 800
	const slidesPerView = el.dataset.slidesperview || 1
	const slidesPerViewResponsive = el.dataset.slidesperviewresponsive || 1
	const slidesPerGroup = el.dataset.slidespergroup || 1
	const slidesPerGroupResponsive = el.dataset.slidespergroupresponsive || 1
	const spaceBetween = el.dataset.spacebetween || 0
	const simulateTouch = el.dataset.freemode ? true : !!el.dataset.simulatetouch
	const pagination = el.dataset.pagination ? {
		el: el.querySelector('.swiper-pagination'),
		type: 'bullets',
		clickable: true
	} : false
	const navigation = el.dataset.navigation ? {
		nextEl: el.querySelector('.swiper-button-next'),
		prevEl: el.querySelector('.swiper-button-prev')
	} : false
	
	let thumbs = false
	
	if (el.dataset.thumbs)
	{
		const slider = document.querySelector(el.dataset.thumbs)
		
		thumbs = {
			swiper: {
				el: slider.querySelector(' .swiper-container'),
				spaceBetween: 0,
				slidesPerView: 1,
				freeMode: false,
				breakpoints: {
					[responsive]: {
						spaceBetween: slider.dataset.spacebetween,
						slidesPerView: slider.dataset.slidesperview,
						freeMode: slider.dataset.freemode
					}
				}
			}
		}
	}
	
	new Swiper(el.querySelector('.swiper-container'), {
		direction: direction,
		autoplay: autoplay,
		loop: loop,
		freeMode: freeMode,
		speed: speed,
		slidesPerView: slidesPerViewResponsive,
		slidesPerGroup: slidesPerGroupResponsive,
		spaceBetween: 0,
		simulateTouch: simulateTouch,
		pagination: pagination,
		navigation: navigation,
		thumbs: thumbs,
		breakpoints: {
			[responsive]: {
				slidesPerView: slidesPerView,
				slidesPerGroup: slidesPerGroup,
				spaceBetween: spaceBetween
			}
		}
	})
}
